/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import { createBootstrap } from 'bootstrap-vue-next'
import { createApp } from 'vue'
import { setupApp } from '@/helpers/Utils'
import { i18n } from '@/plugins/i18n'
import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import Sentry from '@/plugins/sentry'
import '@/assets/scss/main.scss'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'

const app = createApp(App)

app.use(createBootstrap())
app.use(Sentry)
app.use(router)
app.use(store)
app.use(i18n)
;(async () => {
  await setupApp(app)
})()
